import dataLayer from "./dataLayer";
import { toNested } from "./toNested";

/**
 * Usage:
 *   const pageClick = makeClick({ section: 'Product', page: 'EV' });
 *   const heroClick = pageClick.with({ category: 'Hero' });
 *   heroClick({ label: 'Learn More' }); // fires click event
 */
export const makeClick = (base = {}) => {
  const click = (extra = {}) => {
    const resolved = { ...base, ...extra };
    dataLayer.push({ event: "click", ...toNested(resolved) });
  };

  click.with = (more = {}) => makeClick({ ...base, ...more });

  return click;
};

export default makeClick;
